const VueAxios = {
  install (Vue, {axios, csrfToken}) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken()
    Vue.axios = axios
    Vue.prototype.axios = axios
  }
}
export default VueAxios